import styled from "styled-components";
import React from "react";
import { Card } from "../../Components/StyledComponents/PoolStyledComponents";
import Icons from "../../Images";
import environmentVariables from "../../config/environmentVariables";
const InfoIcon = `${environmentVariables?.cdnUrl}infogrey.png`

const Root = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: ${(p) => p.theme.spacing.md};
  margin-bottom: ${(p) => p.theme.spacing.lg};
  @media (max-width: 1100px) {
    flex-direction: column;
    margin-bottom: 30px;
  }
  @media (max-width: 768px) {
    flex-direction: column;
    margin-bottom: 30px;
  }
`;

const RightWrapper = styled.div`
  width: calc(66.66% - 10px);
  @media (max-width: ${(p) => p.theme.screen.md}) {
    width: 100%;
  }
`;

const Div = styled.div`
  /* width:calc(66.66% - 10px); */
  /* width: 100%; */

  display: grid;
  grid-template-columns: 1fr;
  grid-gap: ${(p) => p.theme.spacing.md};
  margin-top: ${(p) => p.theme.spacing.lg};
  /* margin-left: ${(p) => p.theme.spacing.sm}; */
  @media (max-width: 768px) {
    margin-top: 20px;
    grid-gap: 5px;
    width: 100%;
    margin-left: 0;
  }
  @media (max-width: ${(p) => p.theme.screen.xxs}) {
    grid-template-columns: 1fr;
  }
`;
const LeftWrapper = styled.div`
  width: calc(33.33% - 20px);
  @media (max-width: ${(p) => p.theme.screen.md}) {
    width: 100%;
    margin-bottom: ${(p) => p.theme.spacing.sm};
  }
`;
const LeftSection = styled.div`
  background-color: #151a1c;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  padding: ${(p) => p.theme.spacing.sm};
  border-radius: ${(p) => p.theme.radius.xs};
  margin-bottom: ${(p) => p.theme.spacing.xs};
  margin-top: ${(p) => p.theme.spacing.lg};
  padding: ${(p) => p.theme.spacing.md};
  @media (max-width: 768px) {
    margin-top: 20px;
  }
`;
const Title = styled.div`
  font-weight: 500;
  margin-bottom: 10px;
  color: #707070;
  font-size: 18px;
  @media (min-width: 1600px) {
  }
`;
const BoldText = styled.div`
  display: flex;
  align-items: center;
  font-size: ${(p) => p.theme.font.size.md};
  font-weight: ${(p) => p.theme.font.weight.bolder};
  ${(p) =>
    p.mbottom &&
    `
    margin-bottom:${p.theme.spacing[p.mbottom]};
`};
  ${(p) =>
    p.mtop &&
    `
 margin-top:0px;
`};

  @media (min-width: 1600px) {
    font-size: ${(p) => p.theme.font.size.lg};
  }
`;
const SmallText = styled.div`
  display: flex;
  color: #707070;
  font-size: 18px;
  @media (min-width: 1600px) {
  }
`;
const IconWrapper = styled.div`
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: ${(p) => p.theme.colors.white};
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: ${(p) => p.theme.spacing.xs};

  @media (min-width: 1600px) {
    width: 32px;
    height: 32px;
  }
`;
const Icon = styled.img`
  width: 30px;
  @media (min-width: 1600px) {
    width: 40px;
  }
`;
const IconSection = styled.div`
  width: 60px;
  height: 60px;
  background-color: #1c2122;
  margin-right: 10px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  -webkit-transform: perspective(1px) translateZ(0);
  transform: perspective(1px) translateZ(0);
  -webkit-transition-duration: 0.3s;
  transition-duration: 0.3s;
  -webkit-transition-property: transform;
  transition-property: transform;
  :hover,
  :focus,
  :active {
    -webkit-transform: scale(1.2);
    transform: scale(1.2);
  }
`;
const Info = styled.div`
  /* margin-left:-${(p) => p.theme.spacing.xs}; */
`;
const Button = styled.button`
  position: absolute;
  top: 10px;
  right: 10px;
  background: none;
  border: 1px solid ${(p) => p.theme.colors.yellow};
  color: ${(p) => p.theme.colors.yellow};
  padding: ${(p) => p.theme.spacing.xxs} ${(p) => p.theme.spacing.xs};
  border-radius: ${(p) => p.theme.radius.xl};
  font-size: ${(p) => p.theme.font.size.xxs};
  cursor: pointer;
`;

const SmartIcon = styled.img`
  width: 18px;
  @media (min-width: 1600px) {
    width: 20px;
  }
`;

const Line = styled.div`
  width: 100%;
  height: 2px;
  background-color: rgb(51 51 51);
  margin: 5px 0 20px 0;
`;

const Span = styled.span`
  font-size: ${(p) => p.theme.font.size.lg};
  font-weight: ${(p) => p.theme.font.weight.bolder};
  margin-bottom: ${(p) => p.theme.spacing.sm};
  font-family: ${(p) => p.theme.font.family.SweraDemo};
  @media (max-width: ${(p) => p.theme.screen.xxs}) {
    font-size: 24px;
  }
  @media (min-width: 1600px) {
    font-size: ${(p) => p.theme.font.size.xl};
    margin-bottom: ${(p) => p.theme.spacing.md};
  }
`;
const InfoSectionClick = styled.div`
  position: absolute;
  background-color: #fff;
  border-radius: 10px 10px 10px 0;
  padding: 10px 15px;
  bottom: 25px;
  left: 30px;
  color: #767676;
  font-size: 14px;
  font-family: lato;
  letter-spacing: 0.1px;
  max-width: 300px;
  width: 300px;
`;

const InfoIco = styled.img`
  width: 28px;
  height: 28px;
  margin-left: 10px;
  cursor: pointer;
`;
const InfoIcoMain = styled.div`
  position: relative;
`;

const SpanWrapper = styled.div`
  margin-top: 40px;
  @media (max-width: 768px) {
    margin-top: 0;
    margin-bottom: 0;
  }
  @media (max-width: 1024px) {
    margin-top: 0;
    margin-bottom: 0;
  }
`;

const InfoSection = (props) => {
  const {
    LordinfoOpen,
    setLordinfoOpen,
    rewardInfoOpen,
    setRewardInfoOpen,
    HashinfoOpen,
    setHashinfoOpen,
  } = props;
  // console.log(".......//", props.showdata);

  const formatValue = (value, defaultValue = '0') => {
    if (value === undefined || value === null || isNaN(value)) {
      return defaultValue;
    }
    return (parseInt(Number(value)*10000)/10000).toString();
  };
  const formatMLD = (value) => {
    const formattedValue = formatValue(value / 1000000000000000000, '0');
    return `${formattedValue} $MLD`;
  };
  const calculateHashRate = () => {
    if (!props.showdata?.totalHashRate) return '0 $MLD';
    const value = (100 / props.showdata.totalHashRate) * 100;
    return `${value.toFixed(2)} $MLD`;
  };

  const calculateTotalHashRate=()=>{
    if(!props?.showdata?.totalHashRate||!props?.userHash){
      return `0 $MLD`;
    }
    const value=((((((100 / props?.showdata?.totalHashRate) * 100))/100)*props.userHash).toFixed(5));
    return `${value} $MLD`
  }

  return (
    <Root onClick={()=>setRewardInfoOpen(false)}>
      <>
        <LeftWrapper>
          <SpanWrapper>
            {" "}
            <Span>PlatForm Data</Span>
          </SpanWrapper>

          <>
            <LeftSection>
              <>
                <Title>Total Hashrate</Title>
                <BoldText mbottom="sm">
                  {" "}
                  {/* {props?.showdata?.totalHashRate} */}
                  {formatValue(props.showdata?.totalHashRate)}
                </BoldText>
              </>
              <Line />
              <>
                <Title>Total $MLD Distributed</Title>
                <BoldText mbottom="sm">
                  {" "}
                  {formatMLD(props.showdata?.totalDailyEarning)}
                  {/* {props?.showdata?.totalDailyEarning / 1000000000000000000} MLD */}
                </BoldText>
              </>
              <Line />
              <>
                <Title>Pool Size</Title>
                <BoldText mbottom="sm"> 100 $MLD / Day</BoldText>
              </>
              <Line />
              <>
                <Title> 100 Mining HashRate (Within 24hr.) </Title>
                <BoldText mbottom="sm">
                  {/* {props?.showdata?.totalHashRate
                    ? `${(
                        (5000 / props?.showdata?.totalHashRate) *
                        100
                      ).toFixed(2)} MLD`
                    : ""} */}
                     {calculateHashRate()}
                </BoldText>
              </>
            </LeftSection>
          </>
        </LeftWrapper>
      </>

      <RightWrapper >
        <SpanWrapper>
          <Span>User Data</Span>
        </SpanWrapper>
        <Div>
          <Card card1={"card1"}>
            <IconSection>
              <Icon src={Icons.MLDIcon} />
            </IconSection>
            <Info>
              <SmallText>
                Total Lord Allowance
                <InfoIcoMain>
                  <InfoIco
                    onClick={(e) => {
                      e.stopPropagation();
                      setLordinfoOpen(!LordinfoOpen);
                      setHashinfoOpen(false);
                      setRewardInfoOpen(false);
                    }}
                    src={InfoIcon}
                  />
                  {LordinfoOpen && (
                    <InfoSectionClick>
                      The amount of LORD token required per NFT staked
                    </InfoSectionClick>
                  )}
                </InfoIcoMain>
              </SmallText>
              <BoldText>
                {`${props.withdrawalFeesPerc == 0||props.withdrawalFeesPerc == null||props.withdrawalFeesPerc == undefined ? 10 : props.withdrawalFeesPerc} $LORD`} 
              </BoldText>
            </Info>
          </Card>
          <Card card2={"card2"}>
            <IconSection>
              <Icon src={Icons.Totalcost} />
            </IconSection>
            <Info>
              <SmallText>
                {`Total Earnings`}
                <InfoIcoMain>
                  <InfoIco
                    onClick={(e) => {
                      e.stopPropagation();
                      setRewardInfoOpen(!rewardInfoOpen);
                      setHashinfoOpen(false);
                      setLordinfoOpen(false);
                    }}
                    src={InfoIcon}
                  />
                  {rewardInfoOpen && (
                    <InfoSectionClick>
                      {`Total Earnings includes Claimed ( ${props?.userEarnings&&props.unclaimed?Number(props.userEarnings)-Number(props.unclaimed):0} $MLD ) and Unclaimed Rewards ( ${props.unclaimed||0} $MLD ).`}
                    </InfoSectionClick>
                  )}
                </InfoIcoMain>
              </SmallText>
              <BoldText mtop="xs">
                {/* {props?.userEarnings||0} */}
                {`${parseFloat((props?.userEarnings || 0).toFixed(3))} $MLD`}
                {/* {calculateTotalHashRate()} */}
                {/* {((((((5000 / props?.showdata?.totalHashRate) * 100))/100)*props.userHash).toFixed(5)) || 0}  MLD */}
                {/* 0 MLD */}
                {/* <span style={{fontSize:"16px", fontWeight:"500", color:"#c9c9c9", paddingLeft:"10px"}}>( Claimed: 1100 , Unclaimed: 195 )</span> */}
              </BoldText>
            </Info>
          </Card>
          <Card card3={"card3"}>
            <IconSection>
              <Icon src={Icons.PeopleMiningIcon} />
            </IconSection>
            <Info>
              <SmallText>
                Mining Hashrate
                <InfoIcoMain>
                  <InfoIco
                    onClick={(e) => {
                      e.stopPropagation();
                      setHashinfoOpen(!HashinfoOpen);
                      setLordinfoOpen(false);
                      setRewardInfoOpen(false);
                    }}
                    src={InfoIcon}
                  />
                  {HashinfoOpen && (
                    <InfoSectionClick>
                      Your current mining Hashrate
                    </InfoSectionClick>
                  )}
                </InfoIcoMain>
              </SmallText>
              <BoldText mtop="xs">
                {/* {props?.userHash || 0} */}
                {`${parseFloat((props?.userHash || 0).toFixed(3))} $MLD`}
                {/* <IconWrapper><SmartIcon src={Icons.SmartIcon} /></IconWrapper>  */}
              </BoldText>
            </Info>
          </Card>
        </Div>
      </RightWrapper>
    </Root>
  );
};

export default InfoSection;
